export enum KeyboardCode {
  Enter = "Enter",
  Escape = "Escape",
}
